<template>
  <div v-if="splash" class="notlink splashLink" @click="toSite">
    <div id="splashOuter">
      <div id="splashInner" ref="spIn">
        <dvi class="splashTop">
          <div v-html="splash.intro" class="iP"></div>
          <div v-html="splash.date" class="dP"></div>
        </dvi>
        <div id="notice" v-if="splash.notice" v-html="splash.notice"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      intro: null,
      date: null,
      iP: null,
      dP: null,
    };
  },

  computed: {
    splash() {
      return this.$store.getters.splash;
    },

    offline() {
      return this.$store.getters.offline;
    },
  },

  mounted() {
    this.$root.$emit('scrollAfterEnter');
  },

  methods: {
    toSite() {
      let to = this.offline ? 'temporaire' : 'laureats';
      this.$router.push('/' + to);
    },
  },
};
</script>

<style lang="scss">
@import '@/assets/css/variables.scss';
.page-splash {
  a,
  a:hover {
    font-style: normal;
  }
}

.iP {
  width: 60%;
  float: left;
}

.dP {
  width: 40%;
  float: left;
}

.splashLink {
  position: absolute;
  width: 100%;
  height: 100%;
  cursor: pointer !important;
  top: 0;
}

#splashOuter {
  width: 100%;
  min-height: 100%;
  display: flex;
  font-size: $mediumtype;
  padding: 16rem 8rem 2rem;

  #notice {
    margin-top: auto;
    position: relative;
    width: 50%;
    font-size: $bodytype;
  }
}

#splashInner {
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;

  div {
    position: relative;
  }

  p:last-child {
    margin: 0;
  }
}

.spLeft {
  left: 10%;
}

.spRight {
  left: 60%;
}

@media screen and (max-width: $breakPoint1) {
  #splashOuter {
    font-size: $bigtype;
    padding: 30vh 2rem 2rem;

    #notice {
      width: 60%;
      left: 2rem;
      width: 100%;
      padding-bottom: 2rem;
      position: relative;
      bottom: auto;
    }
  }

  .splashTop {
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  .iP {
    left: 2rem;
    top: 0rem;
    margin-bottom: 4rem;
    width: 100%;
  }

  .dP {
    align-items: center;
    display: flex;
    padding-left: 10rem;
    margin-bottom: 4rem;
    flex: 1;
    width: 100%;
  }
}
</style>
